import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contracts/contract";
import Timer from "slotworks/utils/timer";

export default class BlinkSymbolBehaviour extends AbstractSymbolBehaviour {

    public behaviourName: string = "Blink";

    private blinkCount: number;
    private blinkDuration: number;

    private timerId: number;

    private show: boolean;

    /**
     *
     * @param symbol {SymbolComponent}
     * @param [blinkDuration=500] {number}
     * @param [blinkCount=4] {number}
     */
    constructor(symbol: SymbolComponent, blinkDuration: number = 500, blinkCount: number = 2) {
        super(symbol);

        this.blinkDuration = blinkDuration;
        this.blinkCount = blinkCount;
    }

    public static() {
        super.static();

        this.symbol.setLayer(this.matrixLayer);

        Timer.clearInterval(this.timerId);

        this.symbol.setVisible(true);
        this.show = true;
    }

    /**
     * Blinks the symbol 4 times with 500ms between (by default)
     */
    public win(): Contract<void> {
        return new Contract<void>((resolve) => {

            this.symbol.setLayer(this.animationLayer);

            let blinks = this.blinkCount;

            this.timerId = Timer.setInterval(() => {
                this.show = !this.show;
                this.symbol.setVisible(this.show);

                if (this.show) {
                    blinks--;
                }

                if (blinks <= 0) {
                    Timer.clearInterval(this.timerId);

                    resolve(null);
                }
            }, this.blinkDuration);
        });
    }
}
